export enum AttendanceType {
  UNKNOWN = -1,
  ATTENDING = 1,
  MISSING = 2,
  LATE = 3,
}

export const enum AttendanceStatus {
  Unknown = 'unknown',
  Attending = 'attending',
  Missing = 'missing',
  Late = 'late',
}

export const AttendanceMap = {
  '-1': AttendanceStatus.Unknown,
  '1': AttendanceStatus.Attending,
  '2': AttendanceStatus.Missing,
  '3': AttendanceStatus.Late,
} as const;
export type AttendanceMap = typeof AttendanceMap[keyof typeof AttendanceMap];
